// Replace with your actual config/constants
const API_KEY = "AIzaSyDupEqIsExS3DlUro8bz9z7x1Iep6cb2Yo"; 
const BASE_API = "https://www.googleapis.com/blogger/v3/blogs/6746697362430015154";
const PER_PAGE = 5;

export async function fetchPosts(pageToken = null) {
    let url = `${BASE_API}/posts?key=${API_KEY}&fetchBodies=false&maxResults=${PER_PAGE}`;
    if (pageToken) url += `&pageToken=${pageToken}`;

    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Network Error");
        
        const data = await response.json();
        const items = data.items || [];
        
        return {
            posts: items.map(p => ({
                id: p.id,
                title: p.title,
                tag: p.labels && p.labels.length > 0 ? p.labels[0] : "General"
            })),
            nextPageToken: data.nextPageToken || null
        };
    } catch (error) {
        console.error("API Fetch Error:", error);
        throw error;
    }
}